import React from 'react';
/**
 * React Context object to use when directly using the
 * Context Consumer in a React element.
 */
var ThemeContext = React.createContext({});
export default ThemeContext;
